import { TokenIcon } from "@/components/token"
import { Token } from "@/config/tokens"

interface BalanceItemProps {
  balance: {
    token: Token;
    network: string;
    payments: number;
    withdrawals: number;
    available: number;
  };
}

export default function BalanceItem({ balance }: BalanceItemProps) {
  return (
    <div className="flex flex-col gap-4 flex-grow">
      <div className="flex gap-2 flex-grow flex-col">
        <h3 className="text-sm font-normal text-gray-300 flex gap-2 items-center">
          <div>
            <TokenIcon name={balance.token} size={35} />
          </div>
          <div className="flex flex-col items-start">
            {balance.token}
            <span className="text-xs font-normal text-gray-300">
              ({balance.network})
            </span>
          </div>
        </h3>
        <div className="text-md flex font-semibold">
          ${balance.available.toFixed(2)}
        </div>
      </div>
    </div>
  )
}
